export const tableData = {
  content: [
    // Incontinence Rx
    {
      "unique_id": "67e61309b1db0b4cfbd6575c",
      "filename": "fax1820121516.pdf",
      "status": "New",
      "processed_by": "Daniel-Je John",
      "pdfFile": null,
      "createdDatetime": "2025-03-28T03:10:01.838715833",
      "createdByUser": "Webhook",
      "updatedDatetime": "2025-03-28T03:54:43.156859187",
      "updatedByUser": "Daniel-Je John",
      "lastSynced": null,
      "user": null,
      "processed_by_email": "daniel@celeritasai.com",
      "childpdf": null,
      "location": {
          "name": "Bedard Medical Auburn",
          "id": "OLe3e1be00c21b9328d414528a710858bd",
          "description": null,
          "npi": null
      },
      "id": "UNd27cd710da2b198986b46a64a44735c9",
      "locked": false,
      "ocrprocessed": true,
      "faxId": "840344354",
      "tags": [],
      "deleted": false,
      "receivedOn": "2025-03-28T03:08:54+00:00",
      "faxLine": "2075445048",
      "callerId": "6305663153",
      "archived": false,
      "pageCount": 3,
      "alias": "Medical Equipment & Supplies"
    },
    // Split pdf
    {
      unique_id: "67e5cb49b1db0b4cfbd361ad",
      filename: "fax1819998844.pdf",
      status: "New",
      processed_by: "Daniel-Je John",
      pdfFile: null,
      createdDatetime: "2025-03-27T22:03:53.448326542",
      createdByUser: "Scheduler",
      updatedDatetime: "2025-03-28T01:00:27.796930877",
      updatedByUser: "Daniel-Je John",
      lastSynced: null,
      user: null,
      processed_by_email: "daniel@celeritasai.com",
      childpdf: [
        {
          id: "cf4b947219864bbea90cfd7dfe46810b",
          filename: "18199988441.pdf",
          pdfFile: null,
          pages: [1, 2],
          status: "Split",
          processed_by: "Daniel-Je John",
          user: null,
          createdDatetime: "2025-03-27T22:06:06.997090877",
          createdByUser: "Daniel-Je John",
          updatedDatetime: "2025-03-28T01:08:01.204089583",
          updatedByUser: "Daniel-Je John",
          locked: true,
          ocrprocessed: true,
          deleted: false,
        },
        {
          id: "33ce90addca64ef5b5fa2ab3601cf334",
          filename: "18199988442.pdf",
          pdfFile: null,
          pages: [3, 4, 5, 6, 7, 8, 9],
          status: "Split",
          processed_by: "Daniel-Je John",
          user: null,
          createdDatetime: "2025-03-27T22:06:07.336028626",
          createdByUser: "Daniel-Je John",
          updatedDatetime: "2025-03-28T01:10:01.246570966",
          updatedByUser: "Daniel-Je John",
          locked: true,
          ocrprocessed: true,
          deleted: false,
        },
      ],
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        description: null,
        npi: null,
      },
      id: "UNc2560210da2bc9cac7e421034bbdd902",
      locked: false,
      ocrprocessed: true,
      faxId: "840276457",
      tags: [],
      deleted: false,
      receivedOn: "2025-03-27T21:21:15+00:00",
      faxLine: "2075445048",
      callerId: "2062745032",
      archived: false,
      pageCount: 9,
      alias: "Medical Equipment & Supplies",
    },
    // Handwritten
    {
      unique_id: "67af91fc85b6133e35521bd4",
      filename: "fax1798076389.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:00.543257494",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UN11e65110382b51da99642bcd3eab3dcc",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T21:41:48+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828104520",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "6305663210",
      archived: false,
      pageCount: 2,
    },
    // Alden - rx, new pt and provider
    {
      unique_id: "67af91fd85b6133e35521bed",
      filename: "fax1798059520.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:01.283393985",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UN94aef010382bf3386de493f4a6c975fa",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T21:24:46+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828095400",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716778",
      archived: false,
      pageCount: 2,
    },
    // Marie - progress notes, existing patient
    {
      unique_id: "67af91fe85b6133e35521c1b",
      filename: "fax1798074481.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:02.358935915",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UNd8ca2110382b154b1c1460102f4ec6a2",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T21:39:51+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828103455",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716647",
      archived: false,
      pageCount: 3,
    },
    // Joseph demographics
    {
      unique_id: "67af91fd85b6133e35521c00",
      filename: "fax1798088527.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:01.839677323",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UNc9728110382b3b3a17f4c4cfae385482",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T21:55:35+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828111431",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716647",
      archived: false,
      pageCount: 3,
    },
    // Elliot CLaim history
    {
      unique_id: "67af91fc85b6133e35521bca",
      filename: "fax1798094184.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:00.092427019",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UN0b6ea110382b7e0987c4024568f446eb",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T22:02:00+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828114432",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716647",
      archived: false,
      pageCount: 3,
    },
    // Rx -> Elsa use case
    {
      unique_id: "67af91fc85b6133e35521bdf",
      filename: "fax1798106781.pdf",
      status: "New",
      processed_by: null,
      pdfFile: null,
      createdDatetime: "2025-02-14T18:57:00.857607655",
      createdByUser: "Scheduler",
      updatedDatetime: null,
      updatedByUser: null,
      lastSynced: null,
      user: null,
      processed_by_email: null,
      childpdf: null,
      location: {
        name: "Bedard Medical Auburn",
        id: "OLe3e1be00c21b9328d414528a710858bd",
        npi: null,
        description: null,
      },
      id: "UN586ad110382b08bb3ca42651fe3086d6",
      locked: false,
      deleted: false,
      receivedOn: "2025-02-13T22:16:43+00:00",
      alias: "Medical Equipment & Supplies",
      tags: [],
      faxId: "828121270",
      ocrprocessed: true,
      faxLine: "2075445048",
      callerId: "2069716778",
      archived: false,
      pageCount: 2,
    }
  ],
  pageable: {
    sort: {
      empty: false,
      sorted: true,
      unsorted: false,
    },
    offset: 0,
    pageNumber: 0,
    pageSize: 10,
    paged: true,
    unpaged: false,
  },
  totalPages: 1,
  totalElements: 8,
  last: true,
  size: 10,
  number: 0,
  sort: {
    empty: false,
    sorted: true,
    unsorted: false,
  },
  first: true,
  numberOfElements: 8,
  empty: false,
};
